import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"info\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20 32.5c6.904 0 12.5-5.596 12.5-12.5S26.904 7.5 20 7.5 7.5 13.096 7.5 20 13.096 32.5 20 32.5Zm0 1.5c7.732 0 14-6.268 14-14S27.732 6 20 6 6 12.268 6 20s6.268 14 14 14Zm-1.5-20a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm1.5 3.718a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol